/**
 * A purely-CSS animated ellipsis that cycles `.` → `..` → `...` on a loop, for loading-style text
 * (e.g. the "Extracting" badge) where a spinner can't be used. The dots are rendered by a CSS
 * `::after` keyframe (see `.dta-animated-dots` in DataStreamDetails.css) — no JS timers — and are
 * `aria-hidden` so screen readers announce only the adjacent label text.
 */
const AnimatedDots = () => <span className="dta-animated-dots" aria-hidden="true" />

export default AnimatedDots
